import config from '../../../../../../application/config/config';
import CustomList from '../../../Util/List/CustomList/CustomList';
import CustomListContainer from '../../../Util/List/CustomList/CustomListContainer';
import { loadData } from '../../../Util/List/CustomList/loadData';
import { useDispatch, useSelector } from 'react-redux';
import Toast from '../../../Util/Toast/Toast';
import { useEffect, useRef, useState } from 'react';
import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Col,
} from "reactstrap";
import classnames from "classnames";
import CustomCode from '../../../Util/Code/CustomCode';

function List() {

  const dispatch = useDispatch()
  const firstRender = useRef(true);
  const [activeTab, setActiveTab] = useState('list');

  const codeString = `
      //Ao clicar no botão limpar é chamada a callback afterReset 
      let formFilters = {
      ...loadFormFilters(),
      loadData: (preparedValues) => customLoadData(preparedValues, loadData),
      afterReset: async () => {
        await sleep(100)
        dispatch({ type: 'UPDATE_SESSION', key: 'custom_list_reload', value: new Date() });
        dispatch({ type: 'UPDATE_SESSION', key: 'custom_list_filter_reset', value: new Date() });
      }
    };
`;

  setInterval(() => {
    dispatch({ type: 'UPDATE_SESSION', key: 'current_tab_filter_notifications', value: [5, 6] });
  }, 1000)

  const custom_list_filter_reset = useSelector((state) => { return state.session.custom_list_filter_reset });


  useEffect(() => {
      if(firstRender.current) {
          firstRender.current = false;
          return
      }

      Toast.success('Exemplo de acionamento ao limpar filtros')
  },[custom_list_filter_reset])

  const paths = {
    endpoint: config.endpoints.backend + 'core/crudexample/getall'
  }

  const filters = {
    validateOnChange: true,
    showGoBackButton: false,
    showSubmitButton: false,
    handleSubmit: loadData,
    fields: [
      {
        name: 'cnpj',
        type: 'CNPJ',
        label: 'CNPJ',
        validations: {
          required: false
        },
        columnSize: 3
      },
      {
        name: 'gender',
        type: 'select',
        label: 'Gênero',
        isClearable: true,
        options: [
          { label: 'Masculino', value: 'M' },
          { label: 'Feminino', value: 'F' }
        ],
        validations: {
          required: false
        },
        columnSize: 3
      },
      {
        name: 'filtro',
        type: 'submit',
        label: 'Pesquisar',
        columnSize: 1
      },
      {
        name: 'reset',
        type: 'reset',
        label: 'Limpar',
        columnSize: 2
      },
    ],
  }


  let list = {
    labelTitle: 'Lista de empresas (CRUD backend exemplo)',
    labelTitleButtonAdd: 'Incluir nova empresa',
    viewActionColumn: false,
    formFilters: filters,
    columns: [
      {
          name: 'company_name',
          label: 'Empresa'
      },
      {
          name: 'gender',
          label: 'Genêro'
      },
      {
          name: 'cnpj',
          label: 'CNPJ'
      },
  ],
  };

  list = { ...list};

  return (
    <div> 
      <Nav tabs>
        <NavItem>
          <NavLink
            style={{ cursor: "pointer" }}
            className={classnames({ active: activeTab === "list" })}
            onClick={() => {
              setActiveTab("list");
            }}
          >
            Listagem
          </NavLink>
        </NavItem>
       <NavItem>
          <NavLink
            style={{ cursor: "pointer" }}
            className={classnames({ active: activeTab === "codeBox" })}
            onClick={() => {
              setActiveTab("codeBox");
            }}
          >
            Código
          </NavLink>
        </NavItem>
      </Nav>
      <TabContent activeTab={activeTab} className="bg-white">
        <TabPane tabId="list">
          <Col sm="12">
            <CustomListContainer
              pathAdd={list.pathAdd}
              canAdd={false}
              labelTitle={list.labelTitle}
              labelTitleButtonAdd={list.labelTitleButtonAdd}
              content={<CustomList list={{ ...list, ...paths }} />}
            />
          </Col>
        </TabPane>
        <TabPane tabId="codeBox">
          <Col sm="12">
           <CustomCode codeString={codeString} archiveName={'CustomList.js'}/>
          </Col>                          
        </TabPane>
      </TabContent>
    </div>
  );
}
export default List;